<div class="loading-overlay" [class.active]="isLoading">
    <img src="assets/img/loading.gif" class="img-fluid" alt="Cargando información">
    <span class="loading-text">Cargando información...</span>
</div>